import type { MentionState } from './prompt-mention';
import type { PromptInsertContext } from './insert-prompt-into-message';

export function buildPromptInsertContext(
  message: string,
  mention: MentionState,
  cursor: number
): PromptInsertContext | null {
  if (!mention.active || mention.startIndex < 0) return null;
  return {
    before: message.slice(0, mention.startIndex),
    after: message.slice(cursor),
  };
}
